import COM from './Template'

export default COM
